import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { ApiService } from "./api.service";
import { CookieService } from "ngx-cookie-service";
import { AppConfig } from "../Utilities/app-config.service";

@Injectable({
  providedIn: "root"
})
export class AgentActivityListingService {

  constructor(
    private _apiService: ApiService,
    public _appConfig: AppConfig,
    public _httpClient: HttpClient,
  ) {
  }

  getAgentActivityListing() {
    return this._apiService.get(
      this._appConfig.GetUrl("getActivityListing")
    );
  }

  deleteAgentActivity(id: any) {

    let deleteURL = this._appConfig.GetUrl("deleteActivity");
    deleteURL = deleteURL.toString().replace('LSTACTIVITYID', id);
    return this._apiService.delete(deleteURL);
  }

  getAgentActivityDetails(id: any) {
    let activityDetailURL = this._appConfig.GetUrl("getlistingbyid");
    activityDetailURL = activityDetailURL.toString().replace('LSTACTIVITYID', id);

    return this._apiService.get(activityDetailURL);
  }

  downloadTamplate(url: any) {
    return this._httpClient.get(url);
  }

  importListingFile(fileData: any) {

    return this._httpClient.post(
      this._appConfig.baseUrl + this._appConfig.GetUrl("importActivityListing"),
      fileData
    );
  }

  uploadImage(activityID: any,fileData: any) {

    let acitivityUploadImageURL = this._appConfig.GetUrl("uploadimageForCustomListing");
    acitivityUploadImageURL = acitivityUploadImageURL.toString().replace('LSTACTIVITYID', activityID);

    return this._httpClient.post(
      this._appConfig.baseUrl + acitivityUploadImageURL,
      fileData
    );
  }

  getActivityData(id: any) {
    return this._apiService.get (this._appConfig.GetUrl("getlistingbyid") + id);
  }

  updateActivityListingData(modal: any) {

    let activityUpdateURL = this._appConfig.GetUrl("getlistingbyid");
    activityUpdateURL = activityUpdateURL.toString().replace('LSTACTIVITYID', modal.ID);

    return this._apiService.put(activityUpdateURL,modal);
  }

  uploadVideo(fileData: any) {

    return this._httpClient.post(this._appConfig.baseUrl + this._appConfig.GetUrl("uploadVideo"), fileData);
  }

  uploadCover(fileData: any) {

    return this._httpClient.post(this._appConfig.baseUrl + this._appConfig.GetUrl("UploadCoverPhoto"), fileData);
  }

  getMLSNumber() {
    return this._httpClient.get(this._appConfig.baseUrl + this._appConfig.GetUrl("getInsertUpdateMLSNumber"));
  }

  upsertMLSNumber(updateModel: any) {
    return this._httpClient.post(this._appConfig.baseUrl + this._appConfig.GetUrl("getInsertUpdateMLSNumber"), updateModel);
  }
}
